import React, { useState, useContext } from "react";
import { FaTrashRestore } from "react-icons/fa";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../../utils/toast";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ButtonUI from "../../material-ui/ButtonUI";
import { AuthContext } from "../../../context/Auth/AuthContext";
import restoreUser from "../../../api/restoreUser";

const BulkRestorePopup = ({
  setUserRestoredToTrue,
  Userbulkid = [],
  bulkRestoreUser,
  setBulkRestoreUser,
  setRowSelection
}) => {
  const { token } = useContext(AuthContext);

  const handleClose = () => {
    setBulkRestoreUser(false);
  };

  const onBulkRestore = async (Userbulkid) => {
    const restoreAllUserFormResponse = await restoreUser({
      token: token,
      id: Userbulkid,
    });

    if (restoreAllUserFormResponse.code === 200) {
      setRowSelection({});
      setBulkRestoreUser(false);
      setUserRestoredToTrue();
      showSuccess("User/s restored successfully");
    } else {
      showError("Error while bulk restoring user/s");
    }
  };

  return (
    <div className="dialog-modal">
      <Dialog
        open={bulkRestoreUser}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            <FaTrashRestore />
          </div>
          <div className="popup-header-title">Restore User</div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to restore these users ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{ marginTop: "15px" }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            style={{ marginTop: "15px" }}
            autoFocus={true}
            onClickFunc={() => {
              onBulkRestore(Userbulkid);
            }}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BulkRestorePopup;
